import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import JourneyTimeline from "./JourneyTimeline"; 
import "../styles/Journey.css";
function Journey() {
  return (
    <>
   <Helmet>
        <title>Our Journey Since 2009 | Laxmi Hospitality Services</title>
        <meta
          name="description"
          content="Discover Laxmi Hospitality Services' journey from our first client in 2009 to serving 17,500+ meals daily across 25+ industrial locations in India."
        />
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />

        {/* Canonical URL */}
        <link
          rel="canonical"
          href="https://laxmihospitalityservices.in/journey"
        />

        {/* Open Graph Meta Tags */}
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://laxmihospitalityservices.in/journey"
        />
        <meta
          property="og:title"
          content="Our Journey Since 2009 | Laxmi Hospitality Services"
        />
        <meta
          property="og:description"
          content="Discover Laxmi Hospitality Services' journey from our first client in 2009 to serving 17,500+ meals daily across 25+ industrial locations in India."
        />
        <meta property="og:site_name" content="Laxmi Hospitality Services" />
        <meta property="og:locale" content="en_IN" />


        {/* Timeline/Journey-specific JSON-LD Schema */}
        <script type="application/ld+json">
          {`
      {
        "@context": "https://schema.org",
        "@type": "Article",
        "headline": "Our Journey Since 2009 - Laxmi Hospitality Services",
        "description": "The complete story of Laxmi Hospitality Services from 2009 to present, showcasing our growth from serving one client to 25+ industrial locations across India.",
        "datePublished": "2009-01-01T00:00:00+05:30",
        "dateModified":  "2025-01-01T00:00:00+05:30",
        "author": {
          "@type": "Organization",
          "@id": "https://laxmihospitalityservices.in/#organization",
          "name": "Laxmi Hospitality Services",
          "url": "https://laxmihospitalityservices.in"
        },
        "image":["https://laxmihospitalityservices.in/locations/Multi-state-expansion.png"],
        "publisher": {
          "@type": "Organization",
          "@id": "https://laxmihospitalityservices.in/#organization",
          "name": "Laxmi Hospitality Services",
          "url": "https://laxmihospitalityservices.in",
          "image":["https://laxmihospitalityservices.in/logo.png"]        
        },
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://laxmihospitalityservices.in/journey",
          "sameAs":[
         "https://www.linkedin.com/company/laxmi-hospitality-services/",
         "https://www.instagram.com/laxmi_hospitality_services/"
         ]
        },
        "about": {
          "@type": "Organization",
          "@id": "https://laxmihospitalityservices.in/#organization",
          "name": "Laxmi Hospitality Services",
          "url": "https://laxmihospitalityservices.in"
        },
        "mentions": [
          {
            "@type": "Organization",
            "name": "Precise Chemi Pharma Ltd.",
            "description": "Our first client since 2009, still with us today"
          },
          {
            "@type": "Organization", 
            "name": "Suzlon Energy Ltd.",
            "description": "Industry leader served across 7+ locations with 7200+ people"
          },
          {
            "@type": "Organization",
            "name": "Indo Count Industries Ltd.",
            "description": "Recent addition to our clientele in Kolhapur, Maharashtra"
          },
          {
            "@type": "Organization",
            "name": "The Supreme Industries Ltd.",
            "description": "Recent addition to our clientele in Sangli, Maharashtra"
          }
        ]
      }
    `}
        </script>

        {/* Company Timeline/History JSON-LD Schema */}
        <script type="application/ld+json">
          {`
      {
        "@context": "https://schema.org",
        "@type": "Event",
        "name": "Laxmi Hospitality Services Company Journey",
        "description": "16-year journey of growth and excellence in industrial catering services",
        "startDate": "2009-01-01",
        "eventStatus": "https://schema.org/EventScheduled",
        "organizer": {
          "@type": "Organization",
          "@id": "https://laxmihospitalityservices.in/#organization",
          "name": "Laxmi Hospitality Services",
          "url": "https://laxmihospitalityservices.in"          
        },
        "location": {
          "@type": "Place",
          "name": "India",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Mumbai",
            "addressRegion": "Maharashtra",
            "addressCountry": "IN"
          }
        },
          "performer": {
              "@type": "Person",
               "name": "Sadanand Shetty"
          },
          "image":["https://laxmihospitalityservices.in/locations/Multi-state-expansion.png"],
          "subEvent": [
          {
           "@type": "Event",
            "name": "Company Foundation",
            "description": "Founded with Precise Chemi Pharma Ltd. as first client",
            "startDate": "2009-01-01",
            "eventStatus": "https://schema.org/EventScheduled",
            "organizer": {
              "@type": "Organization",
              "@id": "https://laxmihospitalityservices.in/#organization",
              "name": "Laxmi Hospitality Services",
              "url": "https://laxmihospitalityservices.in"
            },
            "location": {
              "@type": "Place",
              "name": "Mumbai, Maharashtra",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Mumbai",
                "addressRegion": "Maharashtra",
                "addressCountry": "IN"
              }
           },    
              "performer": {
              "@type": "Person",
               "name": "Mamata Sadanand Shetty"
               },
              "image":["https://laxmihospitalityservices.in/locations/Foundation.png"]
          },
          {
            "@type": "Event", 
            "name": "Multi-State Expansion",
            "description": "Expanded operations across Maharashtra, Gujarat, Daman, Telangana, and Andhra Pradesh",
            "startDate": "2015-01-01",
            "eventStatus": "https://schema.org/EventScheduled",
            "organizer": {
              "@type": "Organization",
              "@id": "https://laxmihospitalityservices.in/#organization",
              "name": "Laxmi Hospitality Services",
              "url": "https://laxmihospitalityservices.in"
            },
            "location": {
              "@type": "Place",
              "name": "Multiple States, India",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Mumbai",
                "addressRegion": "Maharashtra",
                "addressCountry":"IN"
              }
            },    
            "performer": {
              "@type": "Person",
               "name": "Sadanand Shetty"
               },
            "image":["https://laxmihospitalityservices.in/locations/Multi-state-expansion.png"]
          },
          {
            "@type": "Event",
            "name": "Major Client Partnership",
            "description": "Partnership with Suzlon Energy Ltd. across 7+ locations serving 7200+ people",
            "startDate": "2018-01-01",
            "eventStatus": "https://schema.org/EventScheduled",
            "organizer": {
              "@type": "Organization",
              "@id": "https://laxmihospitalityservices.in/#organization",
              "name": "Laxmi Hospitality Services",
              "url": "https://laxmihospitalityservices.in"
            },
            "location": {
              "@type": "Place",
              "name": "Multiple Locations, India",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Mumbai",
                "addressRegion": "Maharashtra",
                "addressCountry": "IN"
              }
           }, 
            "performer": {
              "@type": "Person",
              "name": "Sadanand Shetty"
               },    
            "image":["https://laxmihospitalityservices.in/clients/Suzlon-3.png"]      
          }
        ]
      }
    `}
        </script>

       {/* -------- JOURNEY PAGE BREADCRUMB -------- */}
       <script type="application/ld+json">
         {`
           {
             "@context": "https://schema.org",
             "@type": "BreadcrumbList",
             "@id": "https://laxmihospitalityservices.in/#breadcrumb",
             "name": "Website Breadcrumb",
             "itemListElement": [
               {
                 "@type": "ListItem",
                 "position": 1,
                 "name": "Home",
                 "item": "https://laxmihospitalityservices.in/"
               },
               {
                 "@type": "ListItem",
                 "position": 2,
                 "name": "Our Journey",
                 "item": "https://laxmihospitalityservices.in/journey"
               }
             ]
           }
         `}
       </script>

   </Helmet>

      <div className="lhs-journey-page">
        <div className="lhs-journey-hero">
          <img
            src="/images/About-us-banner.jpg" 
            alt="The Journey of Laxmi Hospitality Services"
            className="lhs-journey-hero__image"
            title="Hero image for Journey"
          />
          <div className="lhs-journey-hero__overlay">
            <h1 className="lhs-journey-hero__title"> Explore Our Journey</h1>
            <p className="lhs-journey-hero__breadcrumb">
              <Link to="/" className="lhs-journey-hero__breadcrumb-link">
                Home
              </Link>{" "}
              / Journey
            </p>
          </div>
        </div>

        <JourneyTimeline />
      </div>
    </>
  );
}

export default Journey;